<div class="sidebar_collapsed">

  <div class="navigation">
    <div class="nav_items">
      <div class="nav" (click)="toggleSearch()">
        <div class="application-nav-menu-button"
        >
          <app-svg-icon [path]="'assets/icons/search_icon_sb.svg'" class="menu_svg_icon"></app-svg-icon>
        </div>
        <div class="menu_text">Search</div>
      </div>
      @for (menu of menuItems; track menu.id) {
        <div class="nav" (click)="handleClickOnNavItem(menu)">
          <div class="application-nav-menu-button" [ngClass]="{
          'active': isParentActive(menu.id),
          'selecting': isClicked(menu.id)
          }"
          >
            <!--            <img class="menu_icon" alt="" src="{{menu.icon}}">-->
            <app-svg-icon
              [path]="menu?.icon"
              class="menu_svg_icon"
              [ngClass]="{
                  'menu_svg_icon_active': isParentActive(menu.id),
               }"
            ></app-svg-icon>
          </div>
          <div class="menu_text"
               [ngClass]="{
               'text_active': isParentActive(menu.id),
               }"
          >{{ menu.name }}
          </div>
        </div>
      }
    </div>
  </div>
<!--  <div class="footer" (mouseleave)="closeOptions()">
    &lt;!&ndash;    <img class="avatar-icon" alt="" src="assets/icons/avatar.svg" (click)="showSideNavOptions()">&ndash;&gt;
    <div class="avatar_icons" (click)="showSideNavOptions()"
         [ngClass]="{
      'avatar_icons_active': showOptions
    }"
    >
      <img src="assets/icons/admin_menu_icon.svg" />
    </div>

    @if (showOptions) {
      <app-sidebar-options></app-sidebar-options>
    }
  </div>-->

</div>
